<template>
  <div class="supplierMaintenanceLogin">
    <div class="header">
      <img
        src="@/assets/img/login/logo.png"
        alt="智生活 Logo"
      >
    </div>
    <div class="body">
      <div class="title-container">
        <div class="communityName">
          {{ communityName }}
        </div>
        <div class="title">
          廠商維養
        </div>
      </div>
      <div class="form">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
        >
          <el-form-item
            label="手機號碼"
            prop="PhoneNumber"
          >
            <el-input
              v-model="form.PhoneNumber"
              maxlength="10"
              @input="onInput"
            />
          </el-form-item>
          <el-form-item
            label="訪客／廠商名稱"
            prop="Name"
          >
            <el-input v-model="form.Name" />
          </el-form-item>
        </el-form>
      </div>
      <div class="button-container">
        <el-button
          type="primary"
          round
          @click="clickNext"
        >
          下一步
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import jwt_decode from 'jwt-decode'
import { apiAsset } from '../../api/smartBuildingSystemAPI'
import { goToSupplierMaintenance401 } from './js'
export default {
  data () {
    const jwt = this.$route.query.jwt
    let decodedJwt = {}
    let communityName = ''
    try {
      decodedJwt = jwt_decode(jwt)
      communityName = decodedJwt.CommunityName
      const exp = decodedJwt.exp * 1000
      const now = (new Date()).getTime()
      if (exp < now) {
        goToSupplierMaintenance401()
      }
    } catch (error) {
    }
    const rules = {
      PhoneNumber: [
        { required: true, message: '必填欄位不可為空', trigger: 'blur' },
        { pattern: /09\d{8}/, message: '手機格式錯誤，請輸入正確電話號碼', trigger: 'blur' }
      ],
      Name: [
        { required: true, message: '必填欄位不可為空', trigger: 'blur' }
      ]
    }
    return {
      form: {
        PhoneNumber: '',
        Name: ''
      },
      rules,
      jwt,
      decodedJwt,
      communityName
    }
  },
  methods: {
    onInput () {
      this.form.PhoneNumber = this.form.PhoneNumber.replace(/[^0-9]/g, '')
    },
    clickNext () {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            const { data } = await apiAsset.maintenance.postSupplierMaintenanceLogin(this.form, this.jwt)
            const token = data.Token
            this.$router.push({
              name: 'supplierMaintenanceList',
              query: {
                jwt: token
              }
            })
          } catch (error) {
            console.log(error)
          }
        }
      })
    }
  }

}
</script>

<style lang="scss" scoped>
.supplierMaintenanceLogin {
  width: 100%;
  height: 100vh;
  max-height: -webkit-fill-available;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  .header {
    height: 64px;
    background-color: $mainColor;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      height: 39px;
    }
  }
  .body {
    flex-grow: 1;
    padding: 36px 16px;
    display: flex;
    flex-direction: column;
    gap: 32px;
    .communityName,
    .title {
      line-height: 1.5;
    }
    .communityName {
      font-size: 17px;
      text-align: center;
    }
    .title {
      font-size: 25px;
      text-align: center;
      font-weight: bold;
      margin-bottom: 32px;
    }
    .button-container {
      margin-top: auto;
      display: flex;
      justify-content: center;
      button {
        width: 80%;
      }
    }
  }
}
::v-deep .el-form {
  .el-form-item__label {
    text-align: start;
    width: 100%;
  }
}
</style>
